import React from 'react';
import { Sectors } from '../components/Sectors';
export function SectorsPage() {
  return <div className="pt-24 min-h-screen bg-navy-light" data-id="element-229">
      <Sectors data-id="element-230" />
    </div>;
}